export const users = {

    state: {

        users: [
            {
                id: 1,
                firstName: 'Jane',
                lastName: 'Doe',
                email: 'janedoe@pogon.co',
                role: 'Administrator'
            },
            {
                id: 2,
                firstName: 'John',
                lastName: 'Doe',
                email: 'johndoe@pogon.co',
                role: 'Roman'
            }
        ],

        roles: [
            {
                id: 1,
                type: 'Administrator'
            },
            {
                id: 2,
                type: 'Roman'
            }
        ]

    },

    mutations: {

        addUser(state, user) { state.users.push(user) }

    }

}